import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { red } from '@mui/material/colors';
import { Delete as DeleteIcon, Summarize as SummarizeIcon } from '@mui/icons-material';
import { getAvatarUsername, getFullTime } from '../../helper/function';

export default function CardFieldReport(props) {
  const item = props?.item
  return (
    <Card sx={{ maxWidth: 345, borderRadius: "1rem" }} className="shadow">
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
            {getAvatarUsername(item?.createdBy)}
          </Avatar>
        }
        title={item?.judul}
        subheader={item?.createdBy}
      />
      <CardMedia
        component="img"
        height="194"
        image={item?.thumbnail}
        alt="Field report image"
      />
      <CardActions disableSpacing>
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
          <div style={{ paddingLeft: 8 }}>
            {getFullTime(item?.createdAt)}
          </div>
          <div>
            <IconButton aria-label="add to favorites" data-toggle="modal" data-target="#frDetail_modal">
              <SummarizeIcon onClick={() => props?.detailsCallback(item)} />
            </IconButton>
            <IconButton aria-label="share">
              <DeleteIcon onClick={() => props?.deleteCallback(item._id)} />
            </IconButton>
          </div>
        </div>
      </CardActions>
    </Card>
  );
}
